import { useMemo } from 'react';

import { IsoCountryCode2 } from '@rbilabs/intl';

import { useLocale } from 'state/intl';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

const restrictionMap: Partial<Record<IsoCountryCode2, string | string[]>> = {
  // The Spanish franchisee manages Andorra and Gibraltar, so they must be included in the store search
  ES: ['ES', 'GI', 'AD'],
};

export const useGoogleAutocompleteRestrictions =
  (): google.maps.places.AutocompletionRequest['componentRestrictions'] => {
    const { region } = useLocale();
    const countryStoreRestrictionConfig =
      useFlag<IsoCountryCode2 | 'auto'>(
        LaunchDarklyFlag.ENABLE_OVERRIDE_COUNTRY_STORE_RESTRICTION
      ) || 'auto';
    const countryStoreRestriction =
      countryStoreRestrictionConfig === 'auto' ? region : countryStoreRestrictionConfig;

    return useMemo(
      () => ({
        country: restrictionMap[countryStoreRestriction] || countryStoreRestriction,
      }),
      [countryStoreRestriction]
    );
  };
